// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Raw_wrapper__XYZbM","value":"Raw_value__2OrSA"};